module.exports = __webpack_public_path__ + "static/media/SofiaProBlack.18eb5763.otf";